// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a0dV5_f1ibr1zDwRmbhg {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  max-height: calc(100vh - 18rem);
}

.lEkSq1k4OjfFEaU0T2e8 {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.XDGfuKa6XfhZh6djN2IJ {
  display: flex;
  flex-direction: row;
  column-gap: 48px;
  align-items: center;
}

.SNZL6yIvXunY7NqSeWe0 {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.IF9FYdllKy6wjJaEHK8y {
  display: flex;
  flex-direction: row;
  column-gap: 32px;
}

.HXqvawNBSwBEEuXlw1Ub {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
}

.E_HiRrOlEVHddWCkZAT3 {
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
}

.YgAPv3bJZDok4eK6S8QA {
  font-family: Figtree;
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
}

.oMUJbMkts5JnZczWomur {
  min-width: fit-content;
  background: rgba(0, 0, 0, 0.6) !important;
}

.I2Bd1fZiQKML1Is9TdaP {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 16px;
  align-items: center;
  width: 100%;
}

._r8U6s_EU5nrur1TVfnZ {
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 18rem);
  overflow-y: auto;
}

.J7UFj1BVulpCI23ao1wq {
  max-width: 40%;
}

.tXG2LUI8STR3ip3SsRO0 {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/screens/VaultAdministration/VaultAdministration.module.scss"],"names":[],"mappings":"AAIA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,+BAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,yCAAA;AAHJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAJJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ","sourcesContent":[".mainIdoContainer {\r\n\r\n}\r\n\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 32px;\r\n    max-height: calc(100vh - 18rem);\r\n}\r\n\r\n.stakerContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}\r\n\r\n.vaultHeaderContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 48px;\r\n    align-items: center;\r\n}\r\n\r\n.settingsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 32px;\r\n}\r\n\r\n.settingsRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 32px;\r\n}\r\n\r\n.valueContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 4px;\r\n}\r\n\r\n.valueLabel {\r\n    font-family: Bai Jamjuree;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.value {\r\n    font-family: Figtree;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.tabSelector {\r\n    min-width: fit-content;\r\n    background: rgba(0, 0, 0, 0.6) !important;\r\n}\r\n\r\n\r\n.stakerHeaderContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    column-gap: 16px;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n.tableContainer {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-height: calc(100vh - 18rem);\r\n    overflow-y: auto;\r\n}\r\n\r\n.walletInputContainer {\r\n    max-width: 40%;\r\n}\r\n\r\n.flexGrower {\r\n    flex-grow: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `a0dV5_f1ibr1zDwRmbhg`,
	"stakerContainer": `lEkSq1k4OjfFEaU0T2e8`,
	"vaultHeaderContainer": `XDGfuKa6XfhZh6djN2IJ`,
	"settingsContainer": `SNZL6yIvXunY7NqSeWe0`,
	"settingsRow": `IF9FYdllKy6wjJaEHK8y`,
	"valueContainer": `HXqvawNBSwBEEuXlw1Ub`,
	"valueLabel": `E_HiRrOlEVHddWCkZAT3`,
	"value": `YgAPv3bJZDok4eK6S8QA`,
	"tabSelector": `oMUJbMkts5JnZczWomur`,
	"stakerHeaderContainer": `I2Bd1fZiQKML1Is9TdaP`,
	"tableContainer": `_r8U6s_EU5nrur1TVfnZ`,
	"walletInputContainer": `J7UFj1BVulpCI23ao1wq`,
	"flexGrower": `tXG2LUI8STR3ip3SsRO0`
};
export default ___CSS_LOADER_EXPORT___;
